import { render, staticRenderFns } from "./OverflowSection.vue?vue&type=template&id=0f48ca54&scoped=true"
import script from "./OverflowSection.vue?vue&type=script&lang=js"
export * from "./OverflowSection.vue?vue&type=script&lang=js"
import style0 from "./OverflowSection.vue?vue&type=style&index=0&id=0f48ca54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f48ca54",
  null
  
)

export default component.exports